<div class="login"
     fxLayout="column"
     fxLayoutAlign="center center">
    <div class="synapps-logo"></div>
    <div>
        Bienvenue
    </div>
    <div>
        Connectez-vous pour accéder à Synapps en appuyant sur <kbd>Entrée &#9166;</kbd>
    </div>
    <button mat-raised-button
            color="accent"
            fxFlexOffset="2"
            (click)="login()"
            synFocus>
        Se connecter
    </button>
</div>
